import React, {FC} from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../constants/colors';
import {getSolidOrGradientLinearBGColor} from '../../../utils/getSolidOrGradientLinearBGColor';
import {GenericIconName, useSharedIconUrl} from '../Icon/IconName';

export const SaleCloudIcon: FC<{
  className?: string;
  colors?: string[];
  'data-testid'?: string;
}> = ({className, colors = [COLORS.Black], 'data-testid': dataTestid}) => {
  const saleCloudUrl = useSharedIconUrl(GenericIconName.SaleCloud);

  return (
    <Icon
      className={className}
      data-testid={dataTestid}
      $iconUrl={saleCloudUrl}
      style={{
        background: getSolidOrGradientLinearBGColor(colors),
      }}
    />
  );
};

const Icon = styled.div<{$iconUrl: string}>`
  height: 100%;
  left: 0;
  mask-image: url(${({$iconUrl}) => $iconUrl});
  mask-repeat: no-repeat;
  mask-size: 100%;
  position: absolute;
  top: 0;
  width: 100%;
`;
